import { render, staticRenderFns } from "./LabelSwitch.vue?vue&type=template&id=e5168e86&"
import script from "./LabelSwitch.vue?vue&type=script&lang=js&"
export * from "./LabelSwitch.vue?vue&type=script&lang=js&"
import style0 from "./LabelSwitch.vue?vue&type=style&index=0&id=e5168e86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports